const text = (value) => String(value ?? '').trim();
const isoDate = (value) => /^\d{4}-\d{2}-\d{2}$/.test(String(value || '')) && !Number.isNaN(Date.parse(`${value}T00:00:00Z`));

export function createRepairInput({ propertyId, title, description, urgency = 'routine' } = {}) {
  if (!text(propertyId)) throw new Error('Choose a property for this repair report.');
  if (!text(title)) throw new Error('Add a short repair title.');
  if (!text(description)) throw new Error('Describe the issue so it can be coordinated.');
  if (!['emergency', 'urgent', 'routine'].includes(urgency)) throw new Error('Choose a valid urgency.');
  return { property_id: text(propertyId), title: text(title), description: text(description), urgency, status: 'submitted' };
}

export function createJobInput({ organizationId, title, description, deadline, location = '', category = '' } = {}) {
  if (!text(organizationId)) throw new Error('Choose a buyer organization.');
  return createListingInput({ title, description, deadline, location, category, buyer_organization_id: text(organizationId), status: 'draft' });
}

export function createTenderInput({ organizationId, title, description, deadline, location = '', category = '' } = {}) {
  if (!text(organizationId)) throw new Error('Choose a buyer organization.');
  return createListingInput({ title, description, deadline, location, category, buyer_organization_id: text(organizationId), status: 'draft' });
}


export function createHomeJobInput({ title, description, deadline, location = '', category = '', exactAddress = '' } = {}) {
  const item=createListingInput({ title, description, deadline, location, category, status: 'published' });
  if (!text(exactAddress)) throw new Error('Add the service address so the homeowner can coordinate a selected supplier.');
  return { ...item, exact_address: text(exactAddress) };
}

function createListingInput(fields) {
  if (!text(fields.title)) throw new Error('Add a title.');
  if (!text(fields.description)) throw new Error('Add a description.');
  if (!isoDate(fields.deadline)) throw new Error('Add a valid response deadline.');
  return { ...fields, title: text(fields.title), description: text(fields.description), deadline: fields.deadline, location: text(fields.location), category: text(fields.category) };
}

export function canPublishListing({ title, description, deadline } = {}, now = new Date()) {
  const date = Date.parse(`${deadline}T23:59:59Z`);
  return Boolean(text(title) && text(description) && isoDate(deadline) && date >= now.getTime());
}

const repairTransitions = {
  submitted: ['acknowledged', 'cancelled'],
  acknowledged: ['scheduled', 'in_progress', 'cancelled'],
  scheduled: ['in_progress', 'cancelled'],
  in_progress: ['resolved', 'scheduled', 'cancelled'],
  resolved: ['closed', 'in_progress'],
  closed: [],
  cancelled: [],
};
export function canMoveRepairStatus(from, to) { return Boolean(repairTransitions[from]?.includes(to)); }
